import {Dimensions, StyleSheet} from 'react-native';

import {indent} from '/constant/layout.constant';
import {alabaster, grey80, white} from '/theme/color/on.color';
import {alto, darkRed, denim, salmonPink} from '/theme/color/secondary.color';
const height = Dimensions.get('window').height;
export const styles = StyleSheet.create({
  modal: {
    backgroundColor: grey80,
    width: '100%',
    margin: 0,
  },
  modalView: {
    height: height > 684 ? '50%' : '80%',
    marginTop: 'auto',
    backgroundColor: white,
    borderTopLeftRadius: 10,
    borderTopRightRadius: 10,
  },
  modalHeader: {
    flexDirection: 'row',
    padding: 10,
    marginTop: 10,
  },
  modalHeaderText: {
    fontSize: 16,
    fontWeight: '600',
    marginLeft: 10,
  },
  socialContainer: {
    backgroundColor: alabaster,
    paddingBottom: indent * 0.7,
    paddingTop: indent * 2,
    justifyContent: 'center',
    borderWidth: 1,
    borderColor: alto,
    width: '90%',
    marginLeft: indent * 1,
    marginBottom: indent * 1,
    borderRadius: indent * 0.5,
  },
  buttonContainer: {
    alignItems: 'center',
    justifyContent: 'center',
    borderWidth: 1,
    borderColor: alto,
    backgroundColor: white,
    width: '90%',
    marginLeft: indent * 1,
    borderRadius: indent * 0.5,
    marginBottom: indent * 0.5,
  },
  button: {
    marginVertical: indent * 0.5,
    paddingVertical: indent * 0.2,
  },
  secondaryButton: {
    alignItems: 'center',
    marginTop: indent * 0.5,
    marginBottom: 20,
    alignSelf: 'center',
  },
  buttonText: {
    color: denim,
    fontWeight: '500',
  },
  socialLinkBase: {
    marginTop: 0,
    paddingTop: 0,
  },
  socialLink: {
    marginBottom: indent * 0.4,
    paddingLeft: indent * 0.8,
    top: 5,
    position: 'absolute',
  },
  socialLinkProfileAttribute: {
    borderRadius: 8,
    borderWidth: 1,
    borderColor: alto,
    backgroundColor: white,
    marginBottom: indent * 0.4,
    marginTop: 0,
    paddingTop: indent * 0.4,
    paddingBottom: indent * 0.4,
    paddingLeft: indent,
  },
  textLabel: {
    paddingLeft: indent * 1,
    paddingBottom: indent * 0.1,
    fontSize: 14,
  },
  inputBox: {
    borderWidth: 1,
    borderColor: alto,
    backgroundColor: white,
    width: '90%',
    marginLeft: indent * 1,
    borderRadius: indent * 0.4,
    marginBottom: indent * 1,
    height: 50,
    justifyContent: 'center',
  },
  inputText: {
    paddingLeft: indent * 0.5,
  },
  closeButton: {
    position: 'absolute',
    top: 5,
    right: 4,
  },
  cancelButton: {
    alignItems: 'center',
    marginTop: indent * 0.5,
  },
  container: {
    flex: 1,
  },
  fixedButtonContainer: {
    position: 'absolute',
    bottom: 20,
    alignSelf: 'center',
    zIndex: 999,
  },
  inputError: {
    borderColor: salmonPink,
    marginBottom: indent * 0.1,
    height: 50,
  },
  errorLabel: {
    paddingLeft: indent,
    marginBottom: 12,
    color: darkRed,
  },
  // Underline text to avoid relying on color alone for link-style buttons
  focusUnderline: {
    textDecorationLine: 'underline',
  },
});
